module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/katarzyna-drozdowska-2ae7815614636e791bbbafca6e7b2285.webp";